import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UserServiceFormModule } from '@app/account/teacher-page/user-service-form/user-service-form.module';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

import { UserServiceCardFullModule } from '@app/meetings/user-service-card-full/user-service-card-full.module';
import { SchoolClassesComponent } from '@app/schools/school-classes/school-classes.component';
import { EmptyComponent } from '@core/components/empty/empty.component';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { UserServiceCardModule } from '@core/components/service-card/user-service-card.module';

import { IconComponent } from '@shared/icon/icon.component';
import { SpinnersModule } from 'lingo2-forms';
import { UserServiceSurfaceBlockComponent } from '../../meetings/user-service-card-full/user-service-surface-block/user-service-surface-block.component';

@NgModule({
  declarations: [SchoolClassesComponent],
  exports: [SchoolClassesComponent],
  imports: [
    LocaleSharedModule,
    CommonModule,
    IconComponent,
    MobileModalModule,
    ModalModule,
    RouterModule,
    SpinnersModule,

    UserServiceCardModule,
    UserServiceCardFullModule,
    UserServiceFormModule,
    EmptyComponent,
    UserServiceSurfaceBlockComponent,
  ],
})
export class SchoolClassesModule {}
